import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableCardSelector = loadable(() => import('./CardSelector'), {
  fallback: <LoadingScreen />,
});

export default LoadableCardSelector;
